import { getInterventionMenuNavItems } from "@/modules/intervention/intervention-menu-nav/intervention-menu-nav.helper";
import { useInterventionSectionContext } from "@/modules/intervention/intervention-section-context";

export const useInterventionMenuNav = () => {
  const { menuItems, menuSelectedKey, onSectionItemChange } =
    useInterventionSectionContext();

  const { previous, next } = getInterventionMenuNavItems(
    menuItems,
    menuSelectedKey
  );

  return {
    previous,
    next,
    onSectionItemChange,
  };
};
